import { render } from "./PlacementSettingContainer.vue?vue&type=template&id=7deadb9c&scoped=true&ts=true"
import script from "./PlacementSettingContainer.vue?vue&type=script&lang=ts"
export * from "./PlacementSettingContainer.vue?vue&type=script&lang=ts"

import "./PlacementSettingContainer.vue?vue&type=style&index=0&id=7deadb9c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7deadb9c"]])

export default __exports__